import axios from "../axiosPlugin.js";

export const createRole = (data, loading = true) => {
  return axios({
    url: "/api/role/create",
    method: 'post',
    data: {
      data,
      loading
    },
  })
}

export const updateRole = (data, loading = true) => {
  return axios({
    url: "/api/role/update",
    method: 'post',
    data: {
      data,
      loading
    },
  })
}

export const deleteRole = (data, loading = true) => {
  return axios({
    url: "/api/role/delete/" + data.id,
    method: 'get',
    data: {
      data: {},
      loading
    },
  })
}

export const getBrandRole = (data, loading = true, isDefaultAlertTips = true) => {
  return axios({
    url: "/api/role/getBrandRole",
    method: 'get',
    data: {
      data,
      loading,
      isDefaultAlertTips,
    },
  })
}

export const getRoleDetail = (data, loading = true, isDefaultAlertTips = true) => {
  return axios({
    url: "/api/role/detail/" + data.id,
    method: 'get',
    data: {
      data: {},
      loading,
      isDefaultAlertTips
    },
  })
}
